<template>
  <div>
    <div v-for="(group, groupName, groupIndex) in groups" :key="groupIndex" class="container-fluid" :class="{ grayed: groupIndex % 2 === 0 }">
      <div class="container-fixed">
        <section v-if="group.length > 4" class="offset-top-1">
          <h2 class="inline">{{ $t(`common.navigation_${groupName}`) }}</h2>
          <VButton type="button" class="offset-left-1 btn btn-white btn-round" label="<" :aria-label="$t('common.scrollLeft')" @click="onLeft(group)" />
          <VButton type="button" class="offset-left-1 btn btn-white btn-round" label=">" :aria-label="$t('common.scrollRight')" @click="onRight(group)" />
          <div class="row aligncontent offset-top-1 offset-bottom-4" role="list">
            <div class="col-xl-9">
              <transition-group name="navigation-card-list" tag="div" class="row">
                <VCard v-for="card in group.slice(0, 3)" :key="card" class="navigation-card col-xl-4" :name="card" role="listitem" />
              </transition-group>
            </div>
            <transition-group name="navigation-mini-card-list" class="col-xl-3" role="none">
              <VCard v-for="miniCard in group.slice(3)" :key="`m${miniCard}`" class="navigation-mini-card" :name="miniCard" role="listitem" mini />
            </transition-group>
          </div>
        </section>

        <section v-else class="offset-top-1">
          <h2 class="inline">{{ $t(`common.navigation_${groupName}`) }}</h2>
          <div class="row aligncontent offset-top-1 offset-bottom-4">
            <VCard v-for="card in group" :key="card" class="navigation-card col-xl-3" :name="card" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getVisibleNavigationItems } from '@/utils/navigation';

export default {
  name: 'UiNavigationcardsGrouped',

  components: {
    VCard: () => import('@/components/UI/NavigationCards/Card'),
    VButton: () => import('@/components/Button'),
  },

  data() {
    const items = getVisibleNavigationItems(this.$store);
    const groups = {};
    items.forEach((n) => {
      if (!groups[n.parent]) groups[n.parent] = [];
      groups[n.parent].push(n.name);
    });
    return {
      groups,
    };
  },

  updated() {
    btns = this.$el.querySelectorAll('.navigation-card .btn:not(.btn-round)');
    btnObserver = new ResizeObserver(() => {
      resizeBtns();
    });
    Array.from(btns).forEach((btn) => {
      btnObserver.observe(btn);
    });
  },

  methods: {
    onLeft(group) {
      group.unshift(group.pop());
    },

    onRight(group) {
      group.push(group.shift());
    },
  },
};

let btns = [];
let btnObserver;

function resizeBtns() {
  let maxBtnWidth = 0;
  for (let btn of btns) {
    btn.style.minWidth = 'min-content';
    if (btn.offsetWidth > maxBtnWidth) {
      maxBtnWidth = btn.offsetWidth;
    }
  }
  for (let btn of btns) {
    btn.style.minWidth = maxBtnWidth + 'px';
  }
}
</script>

<style scoped>
.inline {
  display: inline-block;
}

.btn-round {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 50%;
}

.navigation-card {
  height: 373px;
}

.navigation-mini-card {
  height: 33.33333%;
}

/* Note: vue gives the last element in the list the -list-move class, if it leaves the list */
.navigation-card-list-enter-active,
.navigation-mini-card-list-enter-active,
.navigation-card-list-leave-active,
.navigation-mini-card-list-leave-active,
.navigation-card-list-move,
.navigation-mini-card-list-move {
  transition: all 0.5s;
}

.navigation-card-list-leave-active,
.navigation-mini-card-list-leave-active {
  position: absolute;
}

.navigation-card-list-enter,
.navigation-card-list-leave-to,
.navigation-mini-card-list-enter,
.navigation-mini-card-list-leave-to {
  opacity: 0;
}

.navigation-card-list-enter:first-child,
.navigation-card-list-leave-to:first-child {
  transform: scale(1, 0.33) translate(300%, 0);
}

.navigation-card-list-enter:last-child,
.navigation-card-list-leave-to:last-child {
  transform: scale(1, 0.33) translate(100%, -50%);
}

.navigation-mini-card-list-enter:first-child,
.navigation-mini-card-list-leave-to:first-child {
  transform: scale(1, 3) translate(-100%, 33%);
}

.navigation-mini-card-list-enter:last-child {
  transform: scale(1, 3) translate(-300%, 0);
}

.navigation-mini-card-list-leave-to:last-child {
  transform: scale(1, 3) translate(-300%, -50%);
}
</style>
